import axios from 'axios';
import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { injectIntl } from "react-intl";
import { useQuery } from 'react-query';
import { useParams } from "react-router-dom";
import Alert from 'react-s-alert';
import Spinner from "react-spinkit";
import useLocalStorage from 'react-use-localstorage';
import SpeakerLogin from '../components/speaker-data/login';
import SpeakerPhoto from '../components/speaker-data/photo';
import PresentationUpload from '../components/speaker-data/presentation-upload';
import VideoUpload from '../components/speaker-data/video-upload';
import VideoWatch from '../components/speaker-data/video-watch';


export const SpeakerData = ({ intl }) => {
  const params = useParams();

  const { event_id, speaker_id, module } = params;
  // this is existing code
  const [token, setToken] = useLocalStorage(`speaker-data-token-${event_id}-${speaker_id}`, "");
// you can see in previous code here they take token value from local storage rite see above then pass this token value in upload video
// component
// now see  video upload component
  const { isLoading, data: event } = useQuery(
    ['event-basic-by-id', event_id],
    () => axios({
      url: `${process.env.REACT_APP_API_HOST}/public/event-basic-by-id/${event_id}`,
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }
    }).then(response => response.data),
    {
      onError: (err) => {
        Alert.error(intl.formatMessage({ id: err.response.data.message }))
      }
    }
  );

  const { isLoading: isLoading2, data: speaker } = useQuery(
    ['speaker', speaker_id],
    () => axios({
      url: `${process.env.REACT_APP_API_HOST}/speaker/me`,
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }).then(response => response.data.data),
    {
      enabled: !!token,
      onError: (err) => {
        Alert.error(intl.formatMessage({ id: err.response.data.message }))
      },
    }
  );

  const { isLoading: isLoading3, data: presentations } = useQuery(
    ['speaker-presentations', event_id, speaker_id],
    () => axios({
      url: `${process.env.REACT_APP_API_HOST}/speaker-data/presentations`,
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }).then(response => response.data),
    {
      enabled: !!token,
      onError: (err) => {
        Alert.error(intl.formatMessage({ id: err.response.data.message }))
      },
    }
  );

  console.log("SpeakerData---1");

  if (isLoading || isLoading2 || isLoading3) {
    return <Spinner spinnerName="wave" />
  }

  if (!token) {
    return <div className="manage-speakers-page">
      <Container>
        <SpeakerLogin eventSlug={event.slug} setToken={setToken} />
      </Container>
    </div>
  }

  return (
    <div className="section-padding-page manage-speakers-page">
      <Container>
        <Row>
          <Col md={10} className="mx-auto">
            <SpeakerPhoto event={event} speaker={speaker} token={token} />
            {
              module === 'video-upload' &&
              <VideoUpload presentations={presentations} token={token} />
              // here you can see token pass in videoUpload component
              // now i am showing my code
            }
            {
              module === 'video-watch' &&
              <VideoWatch eventSlug={event.slug} presentations={presentations} />
            }
            {
              module === 'presentation-upload' &&
              <PresentationUpload presentations={presentations} token={token} />
            }
            <div className="upload-speaker-container b-shadow m-t-60">
              <div className="user-login-row">
                <span>Logged in as <i>{speaker.title} {speaker.firstName} {speaker.lastName}</i></span>
                <Button onClick={() => setToken("")}>Sign out</Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default injectIntl(SpeakerData);
